import { RequestService } from '../../../../../common/services/RequestService';
import { API } from '../../../../../common/api/constants';

export const addCompanyPhoto = async (id, file) => {
  const data = new FormData();
  data.append('image_file', file);
  data.append('company_id', id);
  const URL = API + '/utility/image/upload/company';
  return await RequestService.post(URL, data);
};
